import { logout } from '../../auth.service';
import Login from '../../../pages/Login';

const FranquiaE = () =>
{    
    localStorage.setItem("tenantId", "franquiae");
    localStorage.setItem("logoVertical", "logoSampleclient");
    logout();
    
    return Login();
};

export default FranquiaE;